import React, { useMemo } from "react";

import {
    Card,
    Row,
    Col,
    Select,
    Button,
    Empty
} from "antd";

import {
    DownloadOutlined
} from "@ant-design/icons";

import {
    PDFDownloadLink
} from "@react-pdf/renderer";

import StudentComplainChartPDF from "./StudentComplainChartPDF";


const StudentComplainChart = ({

    complaints = [],

    periods = [],

    gradeClasses = [],

    selectedPeriod,

    setSelectedPeriod,

    selectedGradeClass,

    setSelectedGradeClass,

}) => {



const chartData = useMemo(()=>{


    const students = {};



    complaints.forEach(item=>{


        const studentId = item.student;



        if(!students[studentId]){


            students[studentId]={


                student_id:studentId,


                student_name:
                item.student_full_name || "Unknown Student",


                grade_class:
                item.grade_class_name ||
                item.grade_class ||
                "N/A",


                complaints:[]

            };


        }

students[studentId].complaints.push({
    title: item.title,
    description: item.description,
    period: item.period_name || "N/A",
    date: item.created_at,
    poster_name: item.poster_name || item.poster_username || "Unknown",
    poster_username: item.poster_username || "",
});

});



    const studentList =
    Object.values(students);



    return {


        period:

        periods.find(
            p=>p.id===selectedPeriod
        )?.name || "All Periods",



        grade_class:

        gradeClasses.find(
            g=>g.id===selectedGradeClass
        )?.name || "All Classes",



        total_students:
        studentList.length,



        total_complaints:
        complaints.length,



        students:studentList


    };


},[

complaints,

periods,

gradeClasses,

selectedPeriod,

selectedGradeClass

]);





return (

<Card

style={{

borderRadius:18,

background:"#ffffff",

marginTop:20

}}

>


<Row

gutter={[16,16]}

align="middle"

>


<Col

xs={24}

md={8}

>


<Select

allowClear

size="large"

placeholder="Select Complaint Period"

style={{

width:"100%"

}}


value={selectedPeriod}


onChange={setSelectedPeriod}


options={

periods.map(period=>(

{

value:period.id,

label:period.name

}

))

}


/>


</Col>




<Col

xs={24}

md={8}

>


<Select

allowClear

size="large"

placeholder="Select Grade Class"

style={{

width:"100%"

}}


value={selectedGradeClass}


onChange={setSelectedGradeClass}


options={

gradeClasses.map(item=>(

{

value:item.id,

label:item.name

}

))

}


/>


</Col>





<Col

xs={24}

md={8}

>


{

complaints.length === 0 ?


<Empty

description="No complaints"

/>


:


<PDFDownloadLink


document={


<StudentComplainChartPDF

data={chartData}

/>


}


fileName="Student_Complaint_Report.pdf"


>


{

({loading})=>(


<Button

block

size="large"

type="primary"

icon={<DownloadOutlined/>}


style={{

background:"#d35400",

borderColor:"#d35400"

}}

>


{

loading

?

"Preparing Report..."

:

"Download Complaint Chart"

}


</Button>


)

}


</PDFDownloadLink>


}



</Col>



</Row>



</Card>


);


};


export default StudentComplainChart;